import React, { useState, useEffect } from 'react';
import { ShoppingBag, MessageCircle } from 'lucide-react';

const WHATSAPP_URL = 'https://wa.me/919902506684?text=Hi%2C%20I%20want%20to%20place%20a%20grocery%20order';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-5xl mx-auto px-6 flex items-center justify-between h-16 md:h-[72px]">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2.5 group">
          <span className={`flex items-center justify-center h-9 w-9 rounded-xl transition-colors duration-300 ${
            scrolled ? 'bg-primary' : 'bg-white/15'
          }`}>
            <ShoppingBag className={`h-4.5 w-4.5 transition-colors duration-300 ${
              scrolled ? 'text-white' : 'text-white'
            }`} strokeWidth={1.8} />
          </span>
          <span className={`font-heading text-[17px] font-bold tracking-tight transition-colors duration-300 ${
            scrolled ? 'text-foreground' : 'text-white'
          }`}>
            One Click Essentials
          </span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-1">
          <a
            href="#how-it-works"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
              scrolled
                ? 'text-muted-foreground hover:text-foreground hover:bg-muted/60'
                : 'text-white/75 hover:text-white hover:bg-white/10'
            }`}
          >
            How It Works
          </a>
          <a
            href="#why-us"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
              scrolled
                ? 'text-muted-foreground hover:text-foreground hover:bg-muted/60'
                : 'text-white/75 hover:text-white hover:bg-white/10'
            }`}
          >
            Why Us
          </a>

          <div className="w-px h-5 bg-current opacity-15 mx-2"></div>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-primary text-primary-foreground text-sm font-semibold pl-4 pr-5 py-2.5 rounded-xl hover:bg-accent transition-all duration-300 flex items-center gap-2 shadow-sm hover:shadow-md"
          >
            <MessageCircle className="h-4 w-4" strokeWidth={2} />
            Order on WhatsApp
          </a>
        </div>
      </div>
    </nav>
  );
}
